import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import classNames from 'classnames'
import { useOfferLink, TYPE_LINK, useOfferTags } from 'cityads-v3/hooks/offers'
import { Coupon } from 'cityads-v3/types/coupon';
import { Offer } from 'cityads-v3/types/offers';
import { RootState } from 'cityads-v3/types/reducer';
import classes from './OfferCard.scss'

import AvatarWithFallback from 'cityads-v3/components/ImgWithFallback/AvatarWithFallback'
import Skeleton from '@mui/material/Skeleton'

type OfferCardAvatarProps = {
  offerId: Offer['id']
  entity: Offer | Coupon
  linkSource: string
  isCoupon?: boolean
  avatarClassName?: string
}

export default function OfferCardAvatar({ offerId, entity, linkSource, isCoupon, avatarClassName }: OfferCardAvatarProps) {
  const [link, linkType] = useOfferLink(offerId, linkSource);
  const [, offerTagsByCode] = useOfferTags();
  const displayTags = entity?.tags?.filter(tag => offerTagsByCode[tag]?.isVisible) ?? [];
  const linkClasses = classNames({
    [classes.offerTitle]: true,
  }, ...displayTags.map(tag => classes[`offerTitle--tag--${tag}`]));

  const icons = useSelector((state: RootState) => state.offers[isCoupon ? 'couponOffersById' : 'offersById']?.[offerId]?.icons);

  const avatar = icons?.favicon_svg?.path || null;
  const avatarComponent = (
    <AvatarWithFallback
      src={avatar}
      useImg={true}
      fallbackSrc={[
        icons?.favicon_orig?.path,
        require('./img/default_avatar.svg')
      ]}
      alt={entity
        ? 'translated_name' in entity
          ? entity.translated_name
          : entity.name
        : ''}
      classes={{ root: classNames(classes.offerAvatar, avatarClassName) }}
    />
  )

  return entity
    ? (
      linkType === TYPE_LINK
        ? <Link className={linkClasses} to={link}>{avatarComponent}</Link>
        : typeof link === 'string'
          ? <a className={linkClasses} href={link}>{avatarComponent}</a>
          : null
    )
    : <Skeleton animation="wave" variant="rectangular" width={132} height={54} />

}
